interface OptionPercentageStatProps {
  percentage: number;
  isSelected?: boolean;
  allowResponsiveFlexDirection?: boolean;
}

export function OptionPercentageStat({
  percentage,
  isSelected = false,
  allowResponsiveFlexDirection = false,
}: OptionPercentageStatProps) {
  const colorClass = isSelected ? 'text-[color:var(--color-text-on-light)]' : 'text-white';

  return (
    <div
      className={`flex ${allowResponsiveFlexDirection ? 'flex-row md:flex-col' : 'flex-col'} items-center justify-center gap-0.5 ${colorClass}`}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="size-4 shrink-0"
        aria-hidden
      >
        <path
          d="M8 9.25C9.38071 9.25 10.5 8.13071 10.5 6.75C10.5 5.36929 9.38071 4.25 8 4.25C6.61929 4.25 5.5 5.36929 5.5 6.75C5.5 8.13071 6.61929 9.25 8 9.25Z"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M4.21094 11.4375C4.5949 10.7723 5.1472 10.2199 5.81233 9.83587C6.47745 9.45182 7.23196 9.24963 8 9.24963C8.76804 9.24963 9.52255 9.45182 10.1877 9.83587C10.8528 10.2199 11.4051 10.7723 11.7891 11.4375"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <div className="text-label-sm-bold font-sans capitalize leading-none">{Math.round(percentage)}%</div>
    </div>
  );
}
